import React from 'react';

// Brand pulse line (handoff_app_design/README.md §4.8) — the heartbeat from the logo. Use ONCE
// per screen at most, under the main hero number. Never animated, never decorative elsewhere.
export default function PulseLine({ className = '' }) {
  return (
    <svg
      width="100%"
      height="26"
      viewBox="0 0 360 26"
      preserveAspectRatio="none"
      className={`block text-accent ${className}`}
    >
      <path
        d="M0 16H120l10-12 12 20 10-14 8 6H360"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
